import { uaToDeviceType } from '@cian/ui-kit';

const DEVICE_TYPES_MAP = {
  phone: 'mobile',
  tablet: 'mobile',
  desktop: 'desktop',
};

export const getAnalyticsSiteType = (): string => {
  const deviceType = uaToDeviceType(navigator.userAgent);

  return DEVICE_TYPES_MAP[deviceType];
};
